import React, { useRef } from 'react';

interface FileUploadFieldProps<K extends string> {
    label: string;
    infoLabel?: string;
    file?: File | null;
    noneLabel: string;
    uploadLabel: string;
    error?: string | boolean;
    errorLabel?: string;

    onFileSelect: (e: React.ChangeEvent<HTMLInputElement>, name: K) => void;

    onFileDelete: (name: K) => void;

    fieldName: K;
}

export default function FileUploadField<K extends string>({
    label,
    infoLabel,
    file,
    noneLabel,
    uploadLabel,
    error,
    errorLabel,
    onFileSelect,
    onFileDelete,
    fieldName,
}: FileUploadFieldProps<K>) {
    const fileInputRef = useRef<HTMLInputElement | null>(null);

    const openDialog = () => fileInputRef.current?.click();

    return (
        <>
            {/* --- LEFT LABEL PART --- */}
            <div
                className="col-6 text-left border-right py-4 pl-4"
                style={{ lineHeight: '100%' }}
            >
                {label}
                {infoLabel && (
                    <>
                        <br />
                        <span
                            className="font-weight-light"
                            style={{ fontSize: '12px' }}
                        >
                            {infoLabel}
                        </span>
                    </>
                )}
            </div>

            {/* --- NO FILE SELECTED --- */}
            {!file && (
                <div className="col-6 text-right pt-4 pr-4 alert-light">
                    {noneLabel}

                    <input
                        type="file"
                        hidden
                        ref={fileInputRef}
                        onChange={(e) => onFileSelect(e, fieldName)}
                    />

                    <button className="ml-3" onClick={openDialog} type="button">
                        {uploadLabel}
                    </button>

                    {!!error && (
                        <div className="row">
                            <label className="alert-danger m-auto">
                                {typeof error === 'string' ? error : errorLabel}
                            </label>
                        </div>
                    )}
                </div>
            )}

            {/* --- FILE SELECTED --- */}
            {!!file && (
                <div className="col-6 text-right pt-4 pr-0">
                    <div className="row pr-0">
                        <div className="col-8">{file.name}</div>

                        <div className="col-4 mt-n3">
                            <button
                                onClick={() => onFileDelete(fieldName)}
                                className="btn-no-look"
                                type="button"
                            >
                                <i className="icon-cross"></i>
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}
